<ng-template #shareLabel>
  <sharing-label [sharing]="$value()" />
</ng-template>

<wb-button-overlay [label]="shareLabel" [readonly]="$readonly()" [menuAlignment]="menuAlignment" overlayClass="sharing-field-renderer-overlay">
  <ng-template buttonOverlayContent>
    <div class="sharing-menu" role="group" aria-label="Sharing">
      @for (row of $rows(); track row.toggle) {
        @if (row.dividerBefore) {
          <div class="sharing-menu-divider" role="separator"></div>
        }
        <div class="sharing-menu-row">
          <wb-button-switch [label]="row.label" [checked]="isOn(row.toggle)" [disabled]="isLocked(row.toggle)" (onToggle)="onToggle(row.toggle, $event)" />
        </div>
      }
    </div>
  </ng-template>
</wb-button-overlay>
